import {
    AccountSelectors,
    LocalizationSelectors,
    ModalsService,
    TrackingActions,
} from '@serviceos-ng/core';
import { Observable, of, Subscription } from 'rxjs';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ShareService } from 'ngx-sharebuttons';
import { tap } from 'rxjs/operators';
import { GmailInviteModalComponent } from './gmail-invite-modal/gmail-invite-modal.component';

@Component({
    selector: 'serviceos-web-referral-social',
    templateUrl: './referral-social.component.html',
    styleUrls: ['./referral-social.component.scss'],
})
export class ReferralSocialComponent implements OnDestroy, OnInit {
    @Select(AccountSelectors.referralCode)
    referralCode!: Observable<string>;

    @Output()
    onEvent = new EventEmitter<any>();

    @Input() visualType: 'icon' | 'button' = 'icon';

    @Input() referralDomain: string = window.location.origin;

    @Input() set referralsOptions(value: any) {
        this.referralsArr = Object.keys(value.items)
            .map((key) => {
                const item = value.items[key];

                if (item) {

                    return {
                        ...item,
                        type: key,
                    };
                }
            })
            .filter((el) => !!el);
    }

    referralsArr: any = [];

    public referralLink: string | null = null;
    public subscribe: Subscription | null = null;
    public mapPassed = false;

    public documentDirection = '';

    constructor(
        private store: Store,
        private share: ShareService,
        private modalsService: ModalsService,
        private cdRef: ChangeDetectorRef
    ) {
        // backlog
        // this.share.addButton('gmail', {
        //     type: 'gmail',
        //     func: () => of({}).pipe(tap(() => this.gmail())),
        // });
    }
    
    ngOnInit(): void {

        this.store.select(LocalizationSelectors.getCurrentDirection()).subscribe(
            (currentDirection) => {
                if (currentDirection) {
                    this.documentDirection = currentDirection;
                }
            }
        )
        
        this.share.addButton('whatsapp_desktop', {
            type: 'whatsapp_desktop',
            func: () => of({}).pipe(tap(() => this.whatsappDesktop())),
        });

        this.subscribe = this.referralCode.subscribe((referralCode) => {
            let referralUrl: string = '';

            if (referralCode) {
                this.referralLink = referralUrl = this.referralDomain + '/referral/' + referralCode;
            } else {
                this.referralLink = null;
            }
        });
    }

    whatsappDesktop() {
        const whatsAppConfig = this.referralsArr.find(ref => ref.type === 'whatsapp_desktop'),
            referralCode = this.store.selectSnapshot(AccountSelectors.referralCode),
            referralLink = this.referralDomain + '/referral/' + referralCode,
            newDescription: string = `${whatsAppConfig.description} ${referralLink}`;

        // todo build the link
        const link = `https://wa.me/?text=${newDescription}`;
        
        window.open(link, '_blank');

        this.onEvent.emit({
            type: 'track',
            data: {
                event: 'successfulShare',
                shareType: 'whatsapp'
            }
        });
    }

    shareOpen(type) {
        this.onEvent.emit({
            type: 'track',
            data: {
                event: 'successfulShare',
                shareType: type
            }
        });
    }

    // backlog !!!
    // gmail() {
    //     this.modalsService.open(GmailInviteModalComponent, {
    //         type: 'sidebar',
    //         backdropClickClose: true,
    //     });
    // }

    ngOnDestroy(): void {
        this.subscribe?.unsubscribe();
    }
}
